export function Score({ label, score }) {
  return (
    <div className="flex flex-col items-center gap-2">
      <p className="text-sm">{label}</p>
      <p className="text-2xl font-medium">{score}</p>
    </div>
  );
}
